import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import style from './styles/style.module.css';

class Dashboard extends PureComponent {
    render() {
        return (
            <section className={ style.dashboardPage }>
                <Helmet>
                    <title>Admin - Dashboard</title>
                </Helmet>
                <div className={ style.body }>
                    Admin Dashboard Temporarily Removed
                </div>
            </section>
        );
    }
}

export default connect()( Dashboard );
